import { api } from "../../lib/api";
export const updateProjectAssetDetails = async (partyNumber, projectId, operationType, projectAssetsUpdateRequest) => {
    const { data } = await api.patch(`/projects/${projectId}/assets?partyNumber=${partyNumber}&operationType=${operationType} `, projectAssetsUpdateRequest);
    return { data };
};
